import { Form } from '@audentio/stuff/src/Form';
import { FormControl } from '@audentio/stuff/src/FormControl';
import { Input as DefaultInput } from '@audentio/stuff/src/Input';
import { InputProps } from '@audentio/stuff/src/Input/types';
import { useLocation } from '@reach/router';
import { useTheme } from 'emotion-theming';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
import React, { useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Box } from 'src/components/Box';
import { Button } from 'src/components/Button';
import { Flex } from 'src/components/Flex';
import { Heading } from 'src/components/Heading';
import { string } from 'yup';
import { DualHeading } from '../DualHeading';

export const ContactForm = () => {
    const theme = useTheme();

    return (
        <Flex direction={{ _: 'column', xl: 'row' }}>
            <Flex
                pr={{ _: 0, xl: 20, full: 100 }}
                mb="spacing-lg"
                direction="column"
                position="relative"
            >
                <DualHeading
                    title="Let's get started."
                    subtitle="READY TO BUILD A COMMUNITY?"
                    subtitleColor="bodyText"
                    subtitleMarginBottom={4}
                    kind="h3"
                    mb={4}
                    mt={-20}
                    //maxWidth={480}
                    //fontSize="paragraphTitle"
                />
            </Flex>
            <Flex direction="column" flexGrow={1}>
                <Box textAlign="right">
                    <Button
                        fill={theme.mode === 'dark' ? 'white' : 'black'}
                        style={{ minWidth: 150 }}
                        href="/contact"
                    >
                        Contact us
                    </Button>
                </Box>
            </Flex>
        </Flex>
    );
};
